import React, { useEffect, useState } from "react";
import "./authPage.module.scss";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../store/authReducer";
import { useNavigate } from "react-router-dom";
import "./Login.scss";

const Login = () => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
 
  useEffect(() => {
    const initializeMSAL = async () => {
      await instance.initialize(); // Ensure initialization before using instance
      const storedToken = localStorage.getItem("msalToken");
      if (storedToken && accounts.length > 0) {
        dispatch(loginSuccess(accounts[0], storedToken));
        navigate("/dashboard");
      }
  
      try {
        const response = await instance.handleRedirectPromise();
        if (response && response.account) {
          instance.setActiveAccount(response.account);
          localStorage.setItem("msalToken", response.accessToken);
          localStorage.setItem("msalIdToken", response.idToken);
          dispatch(loginSuccess(response.account, response.accessToken));
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Redirect handling error", error);
      }
    };
  
    initializeMSAL();
  }, [accounts, dispatch, instance, navigate]);  
  const login = async () => {
    try {
      setIsAuthenticating(true);
      await instance.loginRedirect({ scopes: ["User.Read"] });
    } catch (error) {
      console.error("Login failed", error);
    } finally {
      setIsAuthenticating(false);
    }
  };
  // useEffect(() => {
  //   const idToken = localStorage.getItem("msalIdToken");
  //   if (idToken) {
  //     axios.post("http://127.0.0.1:8000/sso/authentication", { token: idToken })
  //       .then(response => {
  //         console.log("SSO Authentication Response:", response.data);
  //       })
  //       .catch(error => {
  //         console.error("SSO Authentication Error:", error);
  //       });
  //   }
  // }, [isAuthenticated]);

  // useEffect(() => {
  //   if (!isAuthenticated && !isAuthenticating) {
  //     login(); // Force re-authentication
  //   }
  // }, [isAuthenticated, isAuthenticating]);

  if (isAuthenticated) {
    return null; // Prevents login screen from flashing
  }

  return (
    <>
      <div className="bg-container">
        <div className="login-card">
          <h2>
            Welcome to <span className="bold-text">TestGeneAI – AI Powered Test Design Engine</span>
            <br/>
           <p style={{
            fontSize: "12px",
            marginTop: "10px"
           }}><i>Accelerate Quality with AI-driven Test Design</i></p>
          </h2>
          <button className="login-button" onClick={login}>
            Sign in
          </button>
          <p className="terms">
            By Continuing, you agree to Agilisium’s <br />
            <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;